import { Utils } from 'ngx-web-api/lib/utils/utils';
import { Group } from '../public_api';
import { CreditCard } from './credit-card.model';

export interface SubscriptionPayment {
  subscriptionName: string;
  subscriptionPeriod: SubscriptionPeriod;
  autoRenew: boolean;
  creditCard: CreditCard;
}

export interface InvoiceSubscription {
  amount: Price;
  status: 'Success' | 'Pending' | 'Failed';
  date: Date;
  orderId: string;
  urlEncodedOrderId?: string;
}

export enum InvoiceStatus {
  success = 'Success',
  pending = 'Pending',
  failed = 'Failed',
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  TRIAL = 'TRIAL',
  SCHEDULED_CANCELLATION = 'SCHEDULED CANCELLATION',
  GRACE_PERIOD = 'GRACE PERIOD',
  FAILED_TO_RENEW = 'FAILED TO RENEW',
}

export enum SubscriptionPeriod {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}

export class LoyaltyPerk {
  perkName: string = '';
  perkOptions: any[] = [];
  perkType: string = '';
  pointsPerDollar?: number;
  //* This should change in the future
  pointsFactorMultiplier?: number;
  percentOff?: number;
  deliveryDiscount?: number;
  price?: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export interface Price {
  price: number;
}

export class LoyaltySubscription {
  subscriptionStatus?: SubscriptionStatus;
  subscriptionName: string;
  subscriptionPeriod: SubscriptionPeriod;
  displayName: string | null;
  description: string | null;
  annualPrice: Price;
  monthlyPrice: Price;
  freeTrialDays: number;
  currentPrice?: Price;
  active: boolean;
  perks: LoyaltyPerk[];
  endDate: number;
  nextPayment: number;
  startDate: number;
  autoRenew: boolean;
  invoices?: InvoiceSubscription[];
  sortOrder?: number;
  loyaltyPerkSpecials?: Group[];
  isActive: boolean;

  readonly inactiveStatuses = [SubscriptionStatus.CANCELLED, SubscriptionStatus.FAILED_TO_RENEW];

  deserialize(input: any): this {
    Object.assign(this, input);

    if (input?.perks && Array.isArray(input?.perks)) {
      this.perks = input?.perks.map((perkData: any) => new LoyaltyPerk().deserialize(perkData));
    } else {
      this.perks = [];
    }

    return this;
  }

  get formattedEndDate() {
    if (!this.endDate) return;
    return Utils.formatDateWithOrdinal(this.endDate);
  }

  get freeTrialDaysInMilliseconds() {
    if (!this.freeTrialDays) return;
    return this.freeTrialDays * 24 * 60 * 60 * 1000;
  }

  get isSubscriptionInitiated(): boolean {
    return !!this.subscriptionName;
  }

  get isSubscriptionInactive(): boolean {
    return this.inactiveStatuses.includes(this.subscriptionStatus) || !this.isSubscriptionInitiated;
  }

  get isSubscriptionActive(): boolean {
    return !this.isSubscriptionInactive;
  }
}

export interface SubscriptionActivationRequest {
  subscriptionName: string;
  subscriptionPeriod: SubscriptionPeriod;
  autoRenew: boolean;
}
